import * as React from "react";
import "rc-slider/assets/index.css";


type filterObject = {
	onlyVacancies: boolean,
	daysRequired: daysRequiredFilterObject,
	overnightEvening: boolean,
	reviews: reviewsFilterObject,
	ratingStandards: ratingStandardFilterObject,
	childsAge: number,
	onlySpecials: boolean,
	price: Array<number>,
	location: locationFilterObject,
}

type daysRequiredFilterObject = {
	mon: boolean,
	tue: boolean,
	wed: boolean,
	thu: boolean,
	fri: boolean,
	sat: boolean,
	sun: boolean,
}

type reviewsFilterObject = {
	fourStar: boolean,
	threeStar: boolean,
	twoStar: boolean,
	all: boolean,
}

type ratingStandardFilterObject = {
	exceeding: boolean,
	excellent: boolean,
	meeting: boolean,
	workingTowards: boolean,
}

type locationFilterObject = {
	exact: boolean,
	fiveKm: boolean,
	tenKm: boolean,
	fifteenKm: boolean,
}

type Props = {
	closeModal: () => void,
	show: boolean,
	updateFilters: (filters: filterObject) => void,
	updateCountRating: (count: number) => void,
	updateCount: (count: any) => void,
	count: number,
	minimumAllowedPrice: number,
	maximumAllowedPrice: number,
	filters: filterObject,
	doSearch: () => void,
	clearFilters: (search: boolean) => void,
	locationModel: any
}

declare var c4kCore: any;

const activeFilterButton = 'button cta-filter';
const inactiveFilterButton = 'button cta-tertiary text-base font-normal border-skin-neutral-light';
export class RatingFilter extends React.Component<Props> {
	eventSuburb: string;
	eventLabel: string;

	constructor(props) {
		super(props);
	}


	SelectRadioFilter = (group: string, item: string) => {
		// Clone filters
		let cloneFilters: filterObject = this.props.filters;

		// Loop through the group of options
		Object.entries(cloneFilters[group]).forEach(([key, value]) => {

			// If the key matches the item, switch it
			if (key == item) {
				cloneFilters[group][key] = !cloneFilters[group][key];
			} else {
				// Else turn it off
				cloneFilters[group][key] = false;
			}
		});

		this.props.updateFilters(cloneFilters);
	}



	// When a filter is selected check the count of filters that are on
	CheckCount = (cloneFilters) => {
		let newCount: number = Object.entries(cloneFilters.reviews).filter(([key, value]) => (value == true && key != "all")).length;

		let newCountFilter: number = Object.entries(cloneFilters.daysRequired).filter(([key, value]) => (value == true && key != "all")).length > 0 ? 1 : 0;
		newCountFilter += Object.entries(cloneFilters.reviews).filter(([key, value]) => (value == true && key != "all")).length;
		newCountFilter += Object.entries(cloneFilters.ratingStandards).filter(([key, value]) => (value == true && key != "all")).length;
		newCountFilter += Object.entries(cloneFilters.location).filter(([key, value]) => (value == true && key != "all")).length;
		newCountFilter += this.props.filters.onlyVacancies ? 1 : 0;
		newCountFilter += this.props.filters.onlySpecials ? 1 : 0;
		newCountFilter += (this.props.filters.price[0] > this.props.minimumAllowedPrice) ? 1 : 0;
		newCountFilter += (this.props.filters.price[1] < this.props.maximumAllowedPrice) ? 1 : 0;
		newCountFilter += this.props.filters.childsAge > 0 ? 1 : 0;
		newCountFilter += (this.props.filters.overnightEvening) ? 1 : 0;

		this.props.updateCountRating(newCount);
		this.props.updateCount(newCountFilter);
	}

	// Handle clicking the overlay outside the modal box
	OverlayClick = (e) => {
		if (e.target.id == 'search-filters-modal') {
			this.HandleClose();
			
		}
	}

	ListenForEscKey = (e) => {
		if (e.keyCode == 27) {
			this.HandleClose();
		}
	}

	HandleClose = () => {
		this.props.closeModal();
		let eventSuburb = `${this.props.locationModel.suburbName}, ${this.props.locationModel.stateAbbreviation}, ${this.props.locationModel.postcode}`;
		let eventLabel = `type=filter_all|source=Srp`;
		c4kCore.analyticsTrackEvent("Search Results", "Search Filters", eventLabel, eventSuburb); //Close
	}

	// Clear Filters
	ClearFilters = () => {
		this.props.clearFilters(true)
		this.props.closeModal()
		let eventSuburb = `${this.props.locationModel.suburbName}, ${this.props.locationModel.stateAbbreviation}, ${this.props.locationModel.postcode}`;
		let eventLabel = `type=filter_all|source=Srp`;
		c4kCore.analyticsTrackEvent("Search Results", "Search Filters", eventLabel, eventSuburb); //Clear
		c4kCore.analyticsTrackEvent("Search Results", "Search Filters", eventLabel, eventSuburb); //Apply
	}

	componentDidMount() {
		document.addEventListener("keydown", this.ListenForEscKey, false);
		this.adjustHeight();

		window.addEventListener('resize', this.adjustHeight);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.ListenForEscKey, false);
		window.removeEventListener('resize', this.adjustHeight);
	}

	adjustHeight = () => {
		const footerTabs = document.getElementById('footer-tabs');
		const wrapperTypesOfCare = document.getElementById("wrapper-search-of-care");
		const buttonGroup = document.getElementById('button-group-search');
		
		if (!footerTabs) {
			wrapperTypesOfCare.style.height = "100%";
			return;
		}
		if (window.getComputedStyle(footerTabs).display === 'none') {
			wrapperTypesOfCare.style.height = "100%";
		} else {
			buttonGroup.style.bottom = '79px';
			wrapperTypesOfCare.style.height = "100%";
			document.getElementById('search-filters-scroll-area').style.paddingBottom = '79px'
			//wrapperTypesOfCare.style.height = "calc(100vh - 132px)";
		}
	}

	doSearch = () => {
		let cloneFilters: filterObject = this.props.filters;
		this.CheckCount(cloneFilters)
		this.props.doSearch()
		this.props.closeModal()
		let eventSuburb = `${this.props.locationModel.suburbName}, ${this.props.locationModel.stateAbbreviation}, ${this.props.locationModel.postcode}`;
		let eventLabel = `type=filter_all|source=Srp`;
		c4kCore.analyticsTrackEvent("Search Results", "Search Filters", eventLabel, eventSuburb); //Apply
	}



	render() {
		// Calculate Age Label
		let age: number = this.props.filters.childsAge;
		let ageLabel;
		if ((age / 12) < 1) {
			ageLabel = <span><span className="mr-2">{this.props.filters.childsAge}</span><span>months</span></span>
		} else {
			ageLabel = <span className="flex gap-2">
				<span>{Math.floor(age / 12)}</span>
				<span>years</span>
				<span>{age % 12}</span>
				<span>months</span>
			</span>
		}

		return (
			<React.Fragment>

				<div
					id="search-filters-modal"
					className={`bg-skin-modal-overlay fixed inset-0 flex items-center justify-center z-102 ${this.props.show ? "" : "hidden"}`}
					aria-modal="true"
					aria-labelledby="modal-title"
					role="dialog"
					onClick={() => this.OverlayClick(event)}
				>
					<div className="bg-skin-modal-box md:rounded-3xl z-70 mx-auto w-full md:w-9/12 lg:w-1/2 h-full md:max-h-80pc bg-skin-filter-modal overflow-y-auto relative">
						{/*<div className="absolute right-8 top-8 flex flex-row items-center justify-center rounded-full bg-white p-2 z-103">*/}
						{/*	<button onClick={this.HandleClose}>*/}
						{/*		<img className="modal-close" src="/img/icons/close-icon.svg" alt="Close icon" />*/}
						{/*	</button>*/}
						{/*</div>*/}

						{/*Modal Body*/}
						<div className="relative" id="wrapper-search-of-care">
							<div className="flex flex-col justify-between h-full relative bg-skin-filter-modal">
								<div id="search-filters-scroll-area" className="pt-8 px-6 lg:px-8 bg-skin-filter-modal overflow-y-auto">
									<div className="text-base font-semibold mb-6 lg:text-3xl lg:font-normal pt-10 lg:pt-0 md:pt-0 flex items-center justify-end">
										<div className="flex flex-row items-center justify-center rounded-full bg-white p-2 z-103">
											<button onClick={this.HandleClose}>
												<img className="modal-close" src="/img/icons/close-icon.svg" alt="Close icon" />
											</button>
										</div>
									</div>

									

									{/*Reviews*/}
									<div className="mb-8">
										<div className="mb-3.5 text-base font-bold">
											Ratings
										</div>
										<div className="flex flex-wrap items-center gap-3">
											<button
												onClick={() => this.SelectRadioFilter("reviews", "fourStar")}
												className={this.props.filters.reviews.fourStar ? activeFilterButton : inactiveFilterButton}>
												4 stars and above
											</button>
											<button
												onClick={() => this.SelectRadioFilter("reviews", "threeStar")}
												className={this.props.filters.reviews.threeStar ? activeFilterButton : inactiveFilterButton}>
												3 stars and above
											</button>
											<button
												onClick={() => this.SelectRadioFilter("reviews", "twoStar")}
												className={this.props.filters.reviews.twoStar ? activeFilterButton : inactiveFilterButton}>
												2 stars and above
											</button>
										</div>
									</div>
									

									
								</div>
								{/*Footer Buttons*/}
								<div className="sticky md:bottom-0 flex flex-row items-center justify-between p-4 lg:px-8 w-full bg-white" id="button-group-search">
									<button
										onClick={() => this.doSearch()}
										className="button cta-primary"
									>
										<span className="items-center gap-1.5" x-bind:class="$store.search.loading == true ? 'flex' : 'hidden'">
											<img src="/img/white-spinner.svg" alt="Spinner white dots circle" /><span>searching...</span>
										</span>
										<span x-bind:class="$store.search.loading == false ? '' : 'hidden'">
											Apply filters
										</span>
									</button>
									<button
										onClick={() => this.ClearFilters()}
										disabled={this.props.count == 0}
										className={`button ${this.props.count == 0 ? "text-gray-300" : "text-black"}`}
									>
										Clear all
									</button>
								</div>

							</div>
						</div> {/*End Modal Body*/}

					</div> {/*End Modal Box*/}



				</div>

			</React.Fragment>
		);

	}

}
